import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    message: String,
  };

  confirm(event) {
    const confirmed = confirm(this.messageValue);
    if (!confirmed) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.target.checked = !event.target.checked;
    }
  }
}
